var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{attrs:{"datetime":_vm.iso,"title":_vm.absolute}},[_vm._v(_vm._s(_vm.relative))])}
var staticRenderFns = []

export { render, staticRenderFns }